export const DATE_INPUT_FORMAT = "YYYY-MM-DD";

export const resolveDateInputFormat = (props = {}) =>
  props.inputFormat || props.valueFormat || DATE_INPUT_FORMAT;
